import { DatePicker } from 'antd';
import { PureComponent, ReactNode } from 'react';
import { EkaFocosableElement } from '../../../../../common/types/EkaFocusable';
import { Element } from './types';
import moment from 'moment';

interface Props {
    index: number;
    element: Element;
    setValue: (ref: string, value?: number) => void;
    handleNextFocus: (index: number, subIndex: number) => void;
    setPropertyInputRef: (ref: EkaFocosableElement | null, index: number, subIndex: number) => void;
}

class DateTimeInput extends PureComponent<Props> {
    render(): ReactNode {
        const { index, element, setValue, handleNextFocus, setPropertyInputRef } = this.props;
        const { ref, label, settings } = element;
        const selectedDate =
            typeof settings.defaultValue === 'number'
                ? moment().add(settings.defaultValue, 'days')
                : undefined;

        return (
            <div className="flex items-center justify-between space-x-16">
                <p>{label}</p>
                <div className="flex items-center justify-end w-40p text-darwin-neutral-600 rounded-4 cursor-pointer">
                    <DatePicker
                        picker={'date'}
                        value={selectedDate}
                        onChange={(t) => {
                            if (t) {
                                const today = moment().startOf('day');
                                const selectedDate = moment(t).startOf('day');
                                const diff = selectedDate.diff(today, 'days');
                                setValue(ref, diff);
                            } else {
                                setValue(ref, undefined);
                            }
                            handleNextFocus(index + 1, 0);
                        }}
                        allowClear={false}
                        format="DD MMM'YY"
                        ref={(ref) => setPropertyInputRef(ref, index, 0)}
                    />
                </div>
            </div>
        );
    }
}

export default DateTimeInput;
